export default "__VITE_ASSET__BNJw67Ve__"